import { useState } from 'react'

import Toast from 'components/Toast'

const { toastMessage } = Toast

const useCopyText = (withToast = false, message = 'Copied text to clipboard successfully') => {
  const [text, setText] = useState('')

  const [isCopied, setIsCopied] = useState(false)

  const handleCopyText = (text: string) => {
    if (isCopied) setIsCopied((prevState) => !prevState)

    setText(text)
    navigator.clipboard.writeText(text)

    if (withToast) toastMessage({ message: message, variant: 'info', duration: 1 })

    setIsCopied((prevState) => !prevState)
  }

  return { text, isCopied, handleCopyText }
}

export default useCopyText
